export default __webpack_public_path__ + "static/media/i-exterior-sura.3d8d9598.svg";